import {
	Client,
	ClientIndexPage,
	OnboardClientRequest,
	SharedData,
} from '@/scripts/types/generated';
import {Page} from '@inertiajs/core';

const clients = ref<Client[]>();
const isLoading = ref<boolean>(false);

export const useClients = () => {
	const refreshClients = (page: Page<ClientIndexPage | SharedData>) => {
		clients.value = page.props.clients;
	};

	const initClients = async () => {
		while (isLoading.value) {
			await new Promise((resolve) => setTimeout(resolve, 100));
		}

		if (clients.value) return;

		isLoading.value = true;
		const page = await sendReloadRequest<SharedData>(['clients']);
		refreshClients(page);
		isLoading.value = false;
	};

	const setClients = (newClients: Client[]) => {
		clients.value = newClients;
	};

	const createClient = async (
		request: OnboardClientRequest
	): Promise<Client> => {
		const page = await sendCreateRequest<ClientIndexPage | SharedData>(
			route('tenant.clients.store'),
			request,
			['clients']
		);

		return new Promise<Client>((resolve) => {
			refreshClients(page);
			const newClient = clients.value.find(
				(client) => client.name === request.name
			);
			resolve(newClient);
		});
	};

	const deleteClient = async (slug: string): Promise<void> => {
		const page = await sendDeleteRequest<ClientIndexPage>(
			route('tenant.clients.destroy', {
				client: slug,
			}),
			['clients']
		);

		return new Promise<void>((resolve) => {
			refreshClients(page);
			resolve();
		});
	};

	return {
		clients,
		initClients,
		setClients,
		createClient,
		deleteClient,
	};
};
